import React, { useState } from "react";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import { RadioContainer } from "../../../components/commons";
import { JOB_TITLE_TYPE_OPTIONS } from "../../../screens/MasterData/JobTitle";
import Select from "react-select";
import { DropDownType } from "../../../commonTypes/clientDirectoryTypes";
import { DropDownUserType } from "../../Jobs/RecurringJobReport/RecurringJobReportHeader";

type AppProps = {
  activeStatus: string;
  activeStatusValue: string;
  setActiveStatus: React.Dispatch<React.SetStateAction<string>>;
  setClearFilter: (data: boolean) => void;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  setActiveStatusValue: React.Dispatch<React.SetStateAction<string>>;
  selectedType: string;
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
  submittedType: string;
  setSubmittedType: React.Dispatch<React.SetStateAction<string>>;
  finalDepartmentList: any;
  filterDepartment: DropDownUserType;
  setFilterDepartment: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  appliedDepartmentFilter: DropDownUserType;
  setAppliedDepartmentFilter: React.Dispatch<
    React.SetStateAction<DropDownUserType>
  >;
  setDepartmentText: React.Dispatch<React.SetStateAction<string>>;
  setDepartmentOffset: React.Dispatch<React.SetStateAction<number>> | undefined;
  departmentFetching: boolean;
  checkDepartmentBottom: (e: any) => void;
  departmentText: string;
  filterCount?: any;
};

export const CATEGORY_STATUS_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "1",
    name: "Active",
  },
  {
    id: "0",
    _id: "0",
    name: "Inactive",
  },
];

const JobTitleFilterModal = ({
  setActiveStatusValue,
  activeStatus,
  activeStatusValue,
  setClearFilter,
  setActiveStatus,
  setOffset,
  selectedType,
  setSelectedType,
  submittedType,
  setSubmittedType,
  finalDepartmentList,
  filterDepartment,
  setFilterDepartment,
  appliedDepartmentFilter,
  setAppliedDepartmentFilter,
  setDepartmentText,
  setDepartmentOffset,
  departmentFetching,
  checkDepartmentBottom,
  departmentText,
  filterCount,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const resetFilterData = () => {
    setActiveStatusValue(activeStatus.toString());
  };

    filterCount = Object?.values(filterCount)?.reduce(
    (acc: any, curr: any) => acc + curr,
    0
  );


  const handleSubmit = () => {
    setActiveStatus(activeStatusValue);
    setClearFilter(false);
    setSubmittedType(selectedType);
    setAppliedDepartmentFilter(filterDepartment);
  };

  const handleSetCategoryStatusRadioValue = (radioValue: string) => {
    setActiveStatusValue(radioValue);
  };

  const handleSetTypeRadioValue = (radioValue: string) => {
    setSelectedType(radioValue);
  };

  const handleDepartmentDropDownChange = (e: any) => {
    setFilterDepartment(e);
  };

  const clearFilter = () => {
    setActiveStatusValue("");
    setActiveStatus("");
    setOffset(0);
    setClearFilter(true);
    setSubmittedType("");
    setAppliedDepartmentFilter({ label: "Select...", value: null });
    setSelectedType("");
    setFilterDepartment({ label: "Select...", value: null });
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle || activeStatusValue || submittedType || filterDepartment?.value
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
                display:"flex",
                alignItems:"center",
              }
            : { 
              border: "1px solid #bfcbe1"
               }
        }
        outline
      >
        <span className={filterCount > 0 ? "payment-count" : ""}>
            <span>{filterCount > 0 ? filterCount : ""}</span>
        </span>
        <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />
      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <label htmlFor="jobStatus" className="mb-2">
              Type
            </label>
            <div>
              <RadioContainer
                optionsList={JOB_TITLE_TYPE_OPTIONS}
                handleSetRadioValue={handleSetTypeRadioValue}
                radioValue={selectedType}
                alignment="horizontal"
              />
            </div>
          </div>
          <div className="mt-4 ml-1">
            <label htmlFor="jobStatus" className="mb-2">
              Status
            </label>
            <div>
              <RadioContainer
                optionsList={CATEGORY_STATUS_RADIO_OPTIONS}
                handleSetRadioValue={handleSetCategoryStatusRadioValue}
                radioValue={activeStatusValue}
                alignment="horizontal"
              />
            </div>
          </div>
          <div>
            <div className="col-md-12 p-0 mt-4">
              <label className="mb-1 mt-2" htmlFor="">
                Department
              </label>

              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={filterDepartment}
                options={finalDepartmentList}
                // isMulti
                isClearable
                onChange={(e) => handleDepartmentDropDownChange?.(e)}
                isSearchable={true}
                isLoading={
                  departmentFetching && (departmentText?.length || 0) > 0
                }
                onMenuClose={() => setDepartmentOffset?.(0)}
                onMenuScrollToBottom={(e: any) => checkDepartmentBottom(e)}
                onInputChange={(e) => {
                  setDepartmentText?.(e);
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default JobTitleFilterModal;
